<i18n lang="yaml">
  pt:
    disconnect: "Desconectar"
    feature: "em breve"
    profile: "ver perfil"
</i18n>

<template>
  <div
    data-grid="column"
    class="user-navigation p-absolute opacity-0"
  >
    <a
      :href="`${connect}/profile?product=checkout`"
      target="_blank"
      class="user-info grid--center grid--va-center"
      data-grid="column"
    >
      <span
        class="picture"
        data-grid="center-center"
      >
        {{ firstLetterName }}
      </span>

      <div
        class="content grid--center grid--va-center"
        data-grid="column"
      >
        <h3>
          {{ name }}
        </h3>

        <small>
          {{ email }}
        </small>
      </div>
    </a>

    <div
      class="panels justify-content-center"
      data-grid="nowrap"
    >
      <a
        v-for="panel in panels"
        :key="panel.id"
        :class="{ feature: panel.feature, lock: currentProject === panel.id }"
        class="panel flex-column"
        data-grid="center-center"
        :href="panel.link"
        target="_blank"
      >
        <img
          :src="panel.image"
          alt="Increazy"
        >
        <small class="mt-1">
          {{ panel.name }}
        </small>
      </a>
    </div>

    <span
      class="disconnect cursor-pointer"
      @click.stop="$logout"
    >
      {{ $t("disconnect") }}
    </span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UserNavigation',

  computed: {
    hasDefinedUser () {
      return this.$user
    },

    connect () {
      return process.env.VUE_APP_INCREAZY_CONNECT
    },

    firstLetterName () {
      if (!this.hasDefinedUser) return ''

      return this.$user.name ? this.$user.name[0] : ''
    },

    name () {
      if (!this.hasDefinedUser) return ''

      const allNames = this.$user.name.split(' ')

      return allNames.join(' ').trim()
    },

    email () {
      if (!this.hasDefinedUser) return ''

      return this.$user.email
    },

    currentProject () {
      return window.location.href.includes('checkout') ? 'checkout' : 'pwa'
    },

    panels () {
      return [
        {
          name: 'Dash Checkout',
          id: 'checkout',
          image: require('../../../assets/images/logos/checkout-square-dark.png'),
          link: 'https://checkout.increazy.com'
        },
        {
          name: 'Dash PWA',
          id: 'pwa',
          image: require('../../../assets/images/logos/dash-square-dark.png'),
          link: '#'
        }
      ]
    }
  }
})
</script>

<style lang="scss" scoped>
  .active .user-navigation {
    max-height: 999px !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  .user-navigation {
    width: 300px;
    min-height: max-content;
    background-color: rgba(var(--white));
    right: 0;
    border-radius: 4px;
    box-shadow: 0 0 15px -2px rgba(var(--black1), 0.2);
    z-index: 10;
    padding: 15px 0;
    max-height: 0;
    visibility: hidden;
    transition: all .4s;
    flex-flow: column;

    .user-info {
      padding: 0 25px 15px;
      border-bottom: 1px solid rgba(var(--gray4), 0.3);

      .picture {
        width: 70px;
        height: 70px;
        border-radius: 50%;

        font-size: 2.5rem;
        font-weight: bold;
        color: rgba(var(--white));
        background-color: var(--primary);
      }

      .content {
        margin-top: 10px;
        color: rgb(var(--white-color, var(--black1)));

        .is-dark-theme & {
          --white-color: var(--gray6);
        }

        h3 {
          font-size: 1.5rem;
        }
      }
    }

    .panels {
      margin: 15px 0;
      padding: 0 25px 15px;
      border-bottom: 1px solid rgba(var(--gray4), 0.3);

      .panel {
        width: max-content;

        &:not(:last-child) {
          margin-right: 20px;
        }

        &:hover img {
          transform: scale(1.1);
        }

        &.feature {
          opacity: 0.7;
          filter: grayscale(1);
          cursor: auto !important;
        }

        &.lock {
          pointer-events: none !important;
        }

        img {
          width: 40px;
          transition: all .4s;
        }

        small {
          font-size: 1.1rem;
          color: rgb(var(--gray1));
        }
      }
    }

    .disconnect {
      align-self: center;
      border: 1px solid var(--error);
      padding: 7px 20px;
      transition: all .4s;

      font-size: 1.2rem;
      color: var(--error);

      &:hover,
      .is-dark-theme & {
        background: var(--error);
        color: rgba(var(--white));
      }
    }

    .is-dark-theme & {
      background-color: rgb(var(--gray8));

      .panels .panel small {
        color: rgb(var(--gray4));
      }
    }
  }
</style>
